<div class="properties-container">
    <!-- Header + barra superior -->
    <div class="properties-header">
        <div class="properties-header-row">
            <!-- Menú superior solo desktop -->
            <div class="menu-desktop" *ngIf="!isMobile">
                <!-- ... tu menú aquí ... -->
            </div>
        </div>
        <h3>Tus propiedades</h3>
        <div class="subtitle">
            Aquí puedes ver y administrar todas tus propiedades.
        </div>
        <div class="properties-bar">
            <input type="text" placeholder="Buscar mis propiedades..." />
            <button class="search-btn">
                <i class="pi pi-search"></i>
            </button>
        </div>
    </div>

    <!-- Cards de propiedades -->
    <div class="property-list">
        <div *ngFor="let property of properties" class="property-card">
            <div class="property-image">
                <img [src]="property.propertyImage" alt="Imagen de propiedad" />
            </div>
            <div class="property-info">
                <div class="info-title">{{ property.propertyName }}</div>
                <div class="info-location">
                    <p>{{ property.zoneName }}, {{ property.cityName }}</p>
                    Renueva el {{ '19/06/2025' }}
                </div>
                <div class="info-actions">
                    <a (click)="editProperty(property)">Continuar</a>
                </div>
            </div>
        </div>
    </div>

    <!-- Ver más -->
    <div class="load-more" *ngIf="loadButtonMore">
        <a (click)="loadMore()">Ver más</a>
    </div>

    <!-- Botones de navegación -->
    <div class="navigation-buttons">
        <button pButton pRipple type="button" class="p-button-info" [routerLink]="'/list'">
            <i class="pi pi-circle-fill custom-circle-fill-icon"></i>
            <span class="px-4">Mis propiedades</span>
        </button>
        <button pButton pRipple class="p-button-secondary">
            <i class="pi pi-circle-fill custom-circle-fill-icon"></i>
            <span class="px-4">Subir una nueva propiedad</span>
            <i class="pi pi-plus custom-arrow-right-icon"></i>
        </button>
    </div>
</div>


